import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetPqrDataHistory } from '../../../../../services/pqr.service';
import { Pqr, PqrFilter } from '../../../../../shared/types/modules/pqr';
import { DateTooltip } from '../../../../components/general/dateTooltip';

export const usePqrHistoryList = (filters?: PqrFilter) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Pqr[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<PqrFilter>({});
    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<Pqr>[] = [
        {
            field: 'id_pqr',
            headerName: 'PQR ID',
            minWidth: 120,
            flex: 0.4,
        },
        {
            field: 'documento_cuenta',
            headerName: 'Cuenta',
            minWidth: 120,
            flex: 0.4,
        },
        {
            field: 'nomnbre_cuenta',
            headerName: 'Nombre de Cuenta',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'producto',
            headerName: 'Producto',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => {
                const date = row.row.created_at?.toString();
                const processedDate = date?.includes(',')
                    ? date.slice(date.indexOf(',') + 1).trim()
                    : date;
                return <DateTooltip date={processedDate} />;
            },
        },
        {
            field: 'state',
            headerName: 'Estado',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'description',
            headerName: 'Descripción',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'close_observation',
            headerName: 'Observación cierre',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'response_channel',
            headerName: 'Medio respuesta',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'notification_email',
            headerName: 'Notificación email',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'notification_phone',
            headerName: 'Notificación telefono',
            minWidth: 150,
            flex: 0.6,
        },
    ];

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        asyncGetPqrDataHistory(finalFilters, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
